<template>
    <div class="goodRank" v-if="list && list.length">
        <div class="auctionFont rankTitle">{{rankTitle}}</div>
        <el-collapse v-model="activeGoodName" :accordion="accordion" class="collapse" ref="collapseRef">
            <template v-for="(item,index) in list">
                <el-collapse-item :key="index" :name="index" class="collapseItem">
                    <template slot="title">
                        <div class="item" @mouseenter="mouseEnterItem(index)">
                            <div class="nameBox fix">
                                <span class="icon auctionFont verdanF12" :class="{'isActive':activeGoodName==index}">{{index+1}}</span>
                                <strong>
                                    <a class="name auctionFont color333" :href="`https://auction.artron.net/paimai-${item.ArtCode}`" target="_blank">{{item.WorkName}}</a>
                                </strong>
                            </div>
                            <div class="priceBox">
                                <span class="label color999 fontSong12">{{title}}：</span>
                                <template v-if="title === '估价'">
                                    <span v-if="item.EvaluationType === 0" class="price red verdanF12">{{item.CurrencyType}} {{ item.OriginalEvaluation == 0 ? '--' : item.OriginalEvaluation.toLocaleString() }} - {{ item.LastEvaluation == 0 ? '--' : item.LastEvaluation.toLocaleString()  }}</span>
                                    <span v-if="item.EvaluationType === 1" class="price red verdanF12">无底价</span>
                                    <span v-if="item.EvaluationType === 2" class="price red verdanF12">资询价</span>
                                    <span v-if="item.EvaluationType === 3" class="price red verdanF12">估价待定</span>
                                </template>
                                <template v-else>
                                    <span class="price red verdanF12">{{item.CurrencyType}} {{item.CurrencyPrice == 0 ? '--' : item.CurrencyPrice.toLocaleString() }}</span>
                                </template>
                            </div>
                        </div>
                    </template>
                    <div class="imgBox">
                        <a  :href="`https://auction.artron.net/paimai-${item.ArtCode}`" target="_blank">
                            <el-image :src="`${item.Folder}${item.FileName}`">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                        </a>
                    </div>
                </el-collapse-item>
            </template>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: "goodRank",
    props:{
        rankTitle:{
            type:String,
        },
        dataLists:{
            type:Object
        },
        list:{
            type:Array
        },
        title:{
            type:String
        },
        t:{
            type:Number
        }
    },
    watch:{
        list(newVal,oldVal){
            if(newVal){
                this.list = newVal
            }
        }
    },
    data(){
        return{
            accordion:true,
            activeGoodName:'0',
            dataList:[
                {id:'1',name:"齐白石 松柏高立",pic:"https://thumb.artron.net//Img/image?src=http://img1.artron.net/auction/2011/art500182/d/art5001821192.jpg&h=100&w=167",url:"http://auction.artron.net/paimai-art5001821192/",price:"RMB 425,500,000 "},
                {id:'2',name:"赵之谦 任颐 齐",pic:"https://auction5-img.artimg.net//Img/image?src=http://img1.artron.net/auction/2010/art6956/d/art69562109.jpg&h=100&w=167",url:"http://auction.artron.net/paimai-art5001821192/",price:"RMB 425,500,000 "},
                {id:'3',name:"齐白石 松柏高立",pic:"https://thumb.artron.net//Img/image?src=http://img1.artron.net/auction/2011/art500182/d/art5001821192.jpg&h=100&w=167",url:"http://auction.artron.net/paimai-art5001821192/",price:"RMB 425,500,000 "},
            ],
        }
    },
    methods:{
        mouseEnterItem(id){
            this.activeGoodName=id;
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.goodRank{
    float: left;
    margin-right: 9px;
    .rankTitle{
        background-color: #ffffff;
        color: #333;
        height: 31px;
        line-height: 31px;
        padding-left: 10px;
        //border-bottom: 1px solid #f2f2f2;
        font-family: 微软雅黑,黑体;
    }
    .collapse{
        .collapseItem{
            overflow: hidden;
        }
        /deep/ .el-collapse-item__arrow{
            display: none;
        }
        /deep/.el-collapse-item__header{
            line-height: 1;
            height: auto;
        }
        /deep/.el-collapse-item__content{
            padding-bottom: 10px;
        }
        .item{
            //background-color: yellow;
            padding: 18px 20px 10px 10px;
            width: 207px;
            .nameBox{
                //height: 15px;
                display: inline-block;
                display: flex;
                .icon{
                    background: url(../../../assets/imgs/old/emBg.png) no-repeat left top;
                    width: 23px;
                    height: 15px;
                    line-height: 14px;
                    display: block;
                    color: #fff;
                    font-style: italic;
                    padding-left: 2px;
                    float: left;
                    &.isActive{
                        background-position: left -25px;
                    }
                }

                strong{
                    float: left;
                    line-height: 15px;
                    margin-left: 5px;
                    color: #333;
                    .name{
                    }
                }

            }
            .priceBox{
                line-height: 12px;
                // height: 20px;
            }
        }
    }
    .imgBox{
        background: #ffffff;
        max-width: 167px;
        height: 100px;
        overflow: hidden;
        padding: 0 10px;
        .el-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
}
</style>